import { useEffect, useRef, useState } from "react";
import api from "../api";
import { useBooksLanguage } from "./booksLanguage";
const labels = {
  id: ["ID", "ID"],
  company_id: ["Фирма ID", "ID firmy"],
  company: ["Фирма", "Firma"],
  settings: ["Настройки", "Ustawienia"],
  accounts: ["План счетов", "Plan kont"],
  bank_accounts: ["Банковские счета", "Rachunki bankowe"],
  vat_history: ["История VAT", "Historia VAT"],
  country: ["Страна", "Kraj"],
  country_code: ["Код страны", "Kod kraju"],
  accounting_system: ["Система учёта", "System księgowy"],
  legal_form: ["Правовая форма", "Forma prawna"],
  name: ["Название", "Nazwa"],
  nip: ["NIP", "NIP"],
  address: ["Адрес", "Adres"],
  currency: ["Валюта", "Waluta"],
  dtype: ["Вид документа", "Rodzaj dokumentu"],
  external_number: ["Номер документа", "Numer dokumentu"],
  document_number: ["Номер документа", "Numer dokumentu"],
  issue_date: ["Дата выставления", "Data wystawienia"],
  posting_date: ["Дата проводки", "Data księgowania"],
  due_date: ["Срок оплаты", "Termin płatności"],
  party: ["Контрагент", "Kontrahent"],
  declared_net: ["Нетто документа", "Netto dokumentu"],
  declared_vat: ["VAT документа", "VAT dokumentu"],
  declared_gross: ["Брутто документа", "Brutto dokumentu"],
  source_document_id: ["Источник ID", "ID dokumentu źródłowego"],
  correction_of_id: ["Корректируемая запись ID", "ID korygowanego dokumentu"],
  settlement_account_id: ["Счёт расчётов", "Konto rozrachunkowe"],
  posting_lines: ["Проводки", "Dekrety"],
  lineitems: ["Позиции документа", "Pozycje dokumentu"],
  description: ["Описание", "Opis"],
  quantity: ["Количество", "Ilość"],
  unit_price: ["Цена за единицу", "Cena jednostkowa"],
  net: ["Нетто", "Netto"],
  vat: ["VAT", "VAT"],
  gross: ["Брутто", "Brutto"],
  rate: ["Ставка VAT %", "Stawka VAT %"],
  vat_regime: ["Режим VAT", "Zasady VAT"],
  account_id: ["Счёт", "Konto"],
  account_code: ["Код счёта", "Kod konta"],
  account_name: ["Название счёта", "Nazwa konta"],
  account_type: ["Тип счёта", "Typ konta"],
  debit: ["Дебет Wn", "Winien"],
  credit: ["Кредит Ma", "Ma"],
  balance: ["Сальдо", "Saldo"],
  posting_state: ["Состояние проводки", "Stan księgowania"],
  review_state: ["Проверка документа", "Weryfikacja dokumentu"],
  settlement_state: ["Состояние оплаты", "Stan rozliczenia"],
  status: ["Статус", "Status"],
  source_lines: ["Строки источника", "Wiersze źródłowe"],
  source_data: ["Данные источника", "Dane źródłowe"],
  header: ["Заголовок", "Nagłówek"],
  metadata: ["Метаданные", "Metadane"],
  policy: ["Политика", "Polityka rachunkowości"],
  filename: ["Имя файла", "Nazwa pliku"],
  kind: ["Вид", "Rodzaj"],
  note: ["Комментарий", "Komentarz"],
  title: ["Заголовок", "Tytuł"],
  document_id: ["Документ ID", "ID dokumentu"],
  source_page: ["Страница источника", "Strona źródła"],
  source_row: ["Строка источника", "Wiersz źródła"],
  entry_date: ["Дата записи", "Data zapisu"],
  journal_entry_id: ["Проводка ID", "ID zapisu dziennika"],
  entry_ids: ["Записи журнала ID", "ID zapisów dziennika"],
  created_at: ["Создано", "Utworzono"],
  updated_at: ["Обновлено", "Zaktualizowano"],
  created_by: ["Автор ID", "ID autora"],
  period_start: ["Начало периода", "Początek okresu"],
  period_end: ["Конец периода", "Koniec okresu"],
  ledger_cutoff: ["Дата границы книг", "Data graniczna ksiąg"],
  bank_cutoff: ["Дата границы банка", "Data graniczna banku"],
  source_status: ["Статус источника", "Status źródła"],
  fiscal_months: ["Фискальные месяцы", "Miesiące roku obrotowego"],
  config: ["Конфигурация", "Konfiguracja"],
  is_active: ["Активен", "Aktywne"],
  code: ["Код", "Kod"],
  number: ["Номер", "Numer"],
  date: ["Дата", "Data"],
  amount: ["Сумма", "Kwota"],
  total: ["Всего", "Łącznie"],
  data: ["Данные", "Dane"],
  lines: ["Строки", "Pozycje"],
  source: ["Источник", "Źródło"],
  source_type: ["Тип источника", "Typ źródła"],
  legacy_id: ["Историческая запись ID", "ID zapisu historycznego"],
  record_id: ["Документ ID", "ID dokumentu operacyjnego"],
  allocation_ids: ["Распределения ID", "ID rozliczeń"],
  bank_allocated: ["Распределено", "Rozliczona kwota"],
  bank_remaining: ["Остаток операции", "Pozostała kwota operacji"],
  notice: ["Примечание", "Uwaga"],
  entry_number: ["Номер записи", "Numer zapisu"],
  period_from: ["Период с", "Okres od"],
  period_to: ["Период по", "Okres do"],
  counterparty: ["Контрагент", "Kontrahent"],
  counterparty_name: ["Контрагент", "Nazwa kontrahenta"],
  counterparty_nip: ["NIP контрагента", "NIP kontrahenta"],
  raw_text: ["Исходный текст", "Tekst źródłowy"],
  raw: ["Исходные данные", "Dane oryginalne"],
  review_status: ["Проверка", "Stan weryfikacji"],
  match_status: ["Сопоставление", "Dopasowanie"],
  classification: ["Классификация", "Klasyfikacja"],
  sha256: ["SHA-256", "SHA-256"],
  size: ["Размер", "Rozmiar"],
  mime_type: ["Тип файла", "Typ pliku"],
  source_id: ["Источник ID", "ID źródła"]
};
const additionalLabels = {
  invoice_number: ["Номер фактуры", "Numer faktury"],
  invoice_type: ["Вид фактуры", "Rodzaj faktury"],
  invoice_id: ["Фактура ID", "ID faktury"],
  document_date: ["Дата документа", "Data dokumentu"],
  source_table: ["Таблица источника", "Tabela źródłowa"],
  source_status: ["Статус источника", "Status źródła"],
  source_header: ["Заголовок источника", "Nagłówek źródłowy"],
  source_payload: ["Полные данные источника", "Pełne dane źródłowe"],
  net_total: ["Итого нетто", "Razem netto"],
  vat_total: ["Итого VAT", "Razem VAT"],
  gross_total: ["Итого брутто", "Razem brutto"],
  buyer_name: ["Покупатель", "Nazwa nabywcy"],
  buyer_nip: ["NIP покупателя", "NIP nabywcy"],
  buyer_address: ["Адрес покупателя", "Adres nabywcy"],
  buyer_email: ["E-mail покупателя", "E-mail nabywcy"],
  seller_name: ["Продавец", "Nazwa sprzedawcy"],
  seller_nip: ["NIP продавца", "NIP sprzedawcy"],
  seller_address: ["Адрес продавца", "Adres sprzedawcy"],
  sale_date: ["Дата продажи", "Data sprzedaży"],
  payment_method: ["Способ оплаты", "Sposób płatności"],
  payment_reference: ["Назначение оплаты", "Tytuł płatności"],
  bank_account: ["Банковский счёт", "Rachunek bankowy"],
  bank_name: ["Название банка", "Nazwa banku"],
  iban: ["IBAN", "IBAN"],
  is_default: ["Основной", "Domyślny"],
  parent_id: ["Родительский счёт ID", "ID konta nadrzędnego"],
  krs: ["KRS", "KRS"],
  is_vat_payer: ["Плательщик VAT", "Podatnik VAT"],
  notes: ["Примечания", "Uwagi"],
  pdf_path: ["Путь PDF", "Ścieżka PDF"],
  user_id: ["Пользователь ID", "ID użytkownika"],
  client_id: ["Клиент ID", "ID klienta"],
  unit: ["Единица", "Jednostka"],
  unit_net_price: ["Цена нетто", "Cena netto"],
  vat_rate: ["Ставка VAT", "Stawka VAT"],
  position: ["Позиция", "Pozycja"],
  policy_status: ["Подтверждение политики", "Potwierdzenie polityki"],
  opening_balances_status: ["Подтверждение начальных сальдо", "Potwierdzenie sald otwarcia"],
  effective_from: ["Действует с", "Obowiązuje od"],
  effective_to: ["Действует по", "Obowiązuje do"],
  vat_status: ["Статус VAT", "Status VAT"],
  receivable: ["Дебиторская задолженность", "Należności"],
  payable: ["Кредиторская задолженность", "Zobowiązania"],
  period: ["Период", "Okres"],
  from: ["С", "Od"],
  to: ["По", "Do"],
  revenue: ["Доходы", "Przychody"],
  cost: ["Расходы", "Koszty"],
  income: ["Результат CIT", "Dochód CIT"],
  tax: ["Налог", "Podatek"],
  advance: ["Аванс", "Zaliczka"],
  debit_account: ["Счёт Wn", "Konto Wn"],
  credit_account: ["Счёт Ma", "Konto Ma"],
  target_account: ["Целевой счёт", "Konto docelowe"]
};
Object.assign(labels, additionalLabels, {blockers:['Причины блокировки','Przyczyny blokady'],valid:['Проверка пройдена','Walidacja poprawna'],duplicate:['Повторное вложение — используется существующий ID','Duplikat załącznika — użyto istniejącego ID'],include_buffer:['Включён буфер','Uwzględniono bufor'],totals:['Итоги','Podsumowanie'],difference:['Разница','Różnica']});
const states = {
  draft: ["Черновик", "Szkic"],
  posted: ["Проведено", "Zaksięgowano"],
  verified: ["Проверено", "Zweryfikowano"],
  reviewed: ["Проверено", "Zweryfikowano"],
  needs_review: ["Требует проверки", "Do weryfikacji"],
  paid: ["Оплачено", "Zapłacono"],
  partial: ["Частично оплачено", "Częściowo rozliczono"],
  unpaid: ["Не оплачено", "Niezapłacone"],
  unknown: ["Не определено", "Nie ustalono"],
  purchase: ["Покупка", "Zakup"],
  sale: ["Продажа", "Sprzedaż"],
  loan: ["Заём", "Pożyczka"],
  own_transfer: ["Собственный перевод", "Przelew własny"],
  standard: ["Стандартный VAT", "VAT standardowy"],
  zero: ["Ставка 0%", "Stawka 0%"],
  exempt: ["Освобождение", "Zwolnienie"],
  outside_scope: ["Вне территории / сферы VAT", "Poza zakresem VAT"],
  reverse_charge: ["Обратное начисление", "Odwrotne obciążenie"],
  buffer: ["Буфер", "Bufor"],
  imported: ["Импортировано", "Zaimportowano"],
  asset: ["Актив", "Aktywa"],
  liability: ["Обязательство", "Zobowiązania"],
  expense: ["Расходы", "Koszty"],
  revenue: ["Доходы", "Przychody"],
  equity: ["Капитал", "Kapitał"]
};
const blockers = {
  missing_issue_date: "Brak daty wystawienia",
  missing_posting_date: "Brak daty księgowania",
  missing_external_number: "Brak numeru dokumentu",
  missing_source_document_id: "Brak dokumentu źródłowego",
  missing_currency: "Brak waluty",
  missing_document_lines: "Brak pozycji dokumentu",
  unknown_net: "Nieustalona kwota netto",
  unknown_vat: "Nieustalona kwota VAT",
  unknown_gross: "Nieustalona kwota brutto",
  inconsistent_net: "Suma netto pozycji różni się od nagłówka",
  inconsistent_vat: "Suma VAT pozycji różni się od nagłówka",
  inconsistent_gross: "Suma brutto pozycji różni się od nagłówka",
  unknown_tax: "Nieustalone zasady lub stawka VAT",
  header_net_plus_vat_not_gross: "Netto + VAT nie równa się brutto",
  source_document_not_verified: "Dokument źródłowy nie został zweryfikowany",
  FX_requires_separate_reviewed_conversion_not_supported: "Waluta obca wymaga oddzielnego zweryfikowanego przeliczenia",
  principal_or_own_transfer_cannot_hit_profit_and_loss: "Kapitał pożyczki i przelew własny nie mogą wpływać na wynik",
  native_journal_amount_limit: "Przekroczono limit kwoty zapisu",
  journal_total_does_not_equal_document_gross: "Suma dekretu nie jest równa brutto dokumentu",
  explicit_settlement_account_required: "Wybierz konto rozrachunkowe",
  settlement_posting_does_not_equal_gross: "Dekret na koncie rozrachunkowym nie odpowiada brutto",
  "At least two journal lines required": "Wymagane co najmniej dwie pozycje dekretu",
  "Unbalanced journal": "Dekret niezbilansowany",
  "Explicit integer account_id required": "Wybierz jawnie konto z planu kont firmy",
  "Only PLN native postings supported; no implicit FX": "Dekrety obsługują wyłącznie PLN; automatyczne przeliczenie walut jest niedozwolone",
  "Exactly one positive debit/credit per line; other side explicit zero": "Każda pozycja wymaga dodatniej kwoty po jednej stronie oraz jawnego zera po drugiej"
};
function fieldLabel(k, t) {
  return labels[k] ? t(...labels[k]) : /^\d+$/.test(k) ? `${t("Позиция", "Pozycja")} ${Number(k) + 1}` : `${t("Поле источника", "Pole źródłowe")}: ${k.replaceAll("_", " ")}`;
}
export function SourceData({
  data
}) {
  const t = useBooksLanguage();
  if (data === null || data === undefined || data === "") return <span>{t("— (нет данных)", "— (brak danych)")}</span>;
  if (typeof data !== "object") return <span>{Object.hasOwn(blockers, data) ? t(`Блокировка проверки: ${data}`, blockers[data]) : Object.hasOwn(states, data) ? t(...states[data]) : typeof data === "boolean" ? t(data ? "Да" : "Нет", data ? "Tak" : "Nie") : String(data)}</span>;
  if (!Object.keys(data).length) return <span>{t("— (нет данных)", "— (brak danych)")}</span>;
  return <dl className="books-data books-source-grid">{Object.entries(data).map(([k, v]) => <div key={k}><dt>{fieldLabel(k, t)}</dt><dd><SourceData data={v} /></dd></div>)}</dl>;
}
function useRead(url, version = 0) {
  const [s, set] = useState({});
  useEffect(() => {
    if (!url) return;
    const c = new AbortController();
    api.get(url, {
      signal: c.signal
    }).then(r => {
      if (!c.signal.aborted) set({
        url,
        version,
        data: r.data
      });
    }).catch(() => {
      if (!c.signal.aborted) set({
        url,
        version,
        error: true
      });
    });
    return () => c.abort();
  }, [url, version]);
  return s.url === url ? s : {};
}
function Load({
  s,
  children
}) {
  const t = useBooksLanguage();
  return s.error ? <p role="alert" className="books-error">{t("Не удалось загрузить данные. Проверьте доступ и обновите.", "Nie udało się pobrać danych. Sprawdź uprawnienia i odśwież.")}</p> : s.data ? children(s.data) : <p role="status">{t("Загрузка…", "Ładowanie…")}</p>;
}
function Button({
  children,
  ...props
}) {
  return <button className="books-button" type="button" {...props}>{children}</button>;
}
function Field({
  name,
  value,
  onChange,
  decimal = false,
  type = "text",
  title
}) {
  const t = useBooksLanguage();
  return <label className="books-field">{title || fieldLabel(name, t)}<input className="books-input" type={type} inputMode={decimal ? "decimal" : undefined} value={value ?? ""} onChange={e => onChange(e.target.value)} /></label>;
}
function Account({
  value,
  onChange,
  accounts,
  title
}) {
  const t = useBooksLanguage();
  return <label className="books-field">{title}<select className="books-input" value={value ?? ""} onChange={e => onChange(e.target.value)}><option value="">{t("— выберите счёт компании", "— wybierz konto firmy")}</option>{accounts.map(a => <option key={a.id} value={a.id}>{a.code || a.account_code} · {a.name || a.account_name}</option>)}</select></label>;
}
function useMutation() {
  const t = useBooksLanguage();
  const [state, set] = useState({});
  const cs = useRef(new Set());
  useEffect(() => {
    const active = cs.current;
    return () => active.forEach(c => c.abort());
  }, []);
  async function run(method, url, payload, done) {
    const c = new AbortController();
    cs.current.add(c);
    set({
      busy: true
    });
    try {
      const r = await api[method](url, payload, {
        signal: c.signal,
        ...(payload instanceof FormData ? { headers: { 'Content-Type': undefined } } : {})
      });
      if (!c.signal.aborted) {
        set({
          result: r.data
        });
        done?.(r.data);
      }
    } catch (e) {
      if (!c.signal.aborted) {
        const detail = e.response?.data?.detail;
        const codes = detail?.blockers;
        set({
          error: codes ? codes.map(k => blockers[k] || t("Сервер отклонил проверку", "Serwer odrzucił walidację") + ` (${k})`).join("; ") : t("Сервер отклонил операцию. Проверьте поля, права, открытый период и подтверждение источника.", "Serwer odrzucił operację. Sprawdź pola, uprawnienia, otwarty okres i weryfikację źródła."),
          technical: typeof detail === "string" ? detail : null
        });
      }
    } finally {
      cs.current.delete(c);
    }
  }
  return {
    state,
    run
  };
}
function Result({
  state
}) {
  const t = useBooksLanguage();
  return <>{state.busy && <p role="status">{t("Сохранение…", "Zapisywanie…")}</p>}{state.error && <div role="alert" className="books-error">{state.error}{state.technical && <details><summary>{t("Технический код сервера", "Komunikat techniczny serwera")}</summary>{state.technical}</details>}</div>}{state.result && <div className="books-notice">{t("Операция выполнена.", "Operacja wykonana.")}<SourceData data={state.result} /></div>}</>;
}
const decimal = v => v == null || String(v).trim() === "" ? null : String(v).trim().replaceAll(/\s/g, "").replace(",", ".");
const identifier = v => v == null || v === "" ? null : Number(v);
const emptyLine = () => ({
  description: "",
  quantity: "",
  unit_price: "",
  net: "",
  vat: "",
  gross: "",
  rate: "",
  vat_regime: "unknown"
});
const emptyRecord = () => ({
  dtype: "purchase",
  currency: "PLN",
  party: {
    name: "",
    nip: "",
    address: "",
    country: ""
  },
  lineitems: [emptyLine()],
  posting_lines: [],
  policy: {},
  metadata: {}
});
const headerFields = ["external_number", "issue_date", "posting_date", "due_date", "currency", "declared_net", "declared_vat", "declared_gross", "correction_of_id"];
function dto(form) {
  const out = {
    dtype: form.dtype,
    party: Object.fromEntries(Object.entries(form.party || {}).map(([k, v]) => [k, v === "" ? null : v])),
    policy: form.policy ?? {},
    metadata: form.metadata ?? {}
  };
  headerFields.forEach(k => {
    out[k] = k.startsWith("declared_") ? decimal(form[k]) : k === "correction_of_id" ? identifier(form[k]) : form[k] || null;
  });
  ["source_document_id", "settlement_account_id"].forEach(k => out[k] = identifier(form[k]));
  out.lineitems = (form.lineitems || []).map(l => ({
    ...l,
    ...Object.fromEntries(["quantity", "unit_price", "net", "vat", "gross", "rate"].map(k => [k, decimal(l[k])])),
    description: l.description || null
  }));
  out.posting_lines = (form.posting_lines || []).map(l => ({
    account_id: identifier(l.account_id),
    debit: decimal(l.debit),
    credit: decimal(l.credit),
    currency: "PLN"
  }));
  return out;
}
export function Operations({
  base,
  version,
  refresh,
  download
}) {
  const t = useBooksLanguage();
  const ledger = base.replace("/books/", "/books-ledger/");
  const [offset, setOffset] = useState(0);
  const [selection, setSelection] = useState(null);
  const [newForm, setNewForm] = useState(false);
  const [local, setLocal] = useState(0);
  const records = useRead(`${ledger}/records?offset=${offset}&limit=25`, version + local);
  const settings = useRead(`${base}/settings`, version);
  const sources = useRead(`${base}/reports`, version + local);
  const detail = useRead(selection ? `${ledger}/records/${selection}` : null, version + local);
  const [payment, setPayment] = useState({
    bank_transaction_id: "",
    bank_account_id: "",
    allocations: [{
      record_id: "",
      amount_pln: ""
    }]
  });
  const mutation = useMutation();
  const bump = () => {
    setLocal(v => v + 1);
    refresh();
  };
  const accounts = settings.data?.accounts || [];
  return <><h2>{t("Оперативные документы", "Dokumenty operacyjne")}</h2><p className="books-notice">{t("Источник → проверка → проводка → оплата — отдельные этапы. Страна компании не определяет автоматически налоговую политику.", "Źródło → weryfikacja → księgowanie → rozliczenie to oddzielne etapy. Kraj firmy nie ustala automatycznie polityki podatkowej.")}</p><Button onClick={() => {
      setSelection(null);
      setNewForm(true);
    }}>{t("Новый документ", "Nowy dokument")}</Button><Load s={records}>{data => <><div className="books-table-wrap"><table className="books-table"><thead><tr>{["id", "external_number", "dtype", "issue_date", "declared_gross", "review_state", "posting_state", "settlement_state"].map(k => <th key={k}>{fieldLabel(k, t)}</th>)}<th>{t("Действия", "Działania")}</th></tr></thead><tbody>{(data.records || []).map(r => <tr key={r.id}>{["id", "external_number", "dtype", "issue_date", "declared_gross", "review_state", "posting_state", "settlement_state"].map(k => <td key={k}><SourceData data={r[k]} /></td>)}<td><Button onClick={() => {
                    setSelection(r.id);
                    setNewForm(false);
                  }}>{t("Открыть", "Otwórz")}</Button></td></tr>)}</tbody></table>{!data.records?.length && <p>{t("Нет документов.", "Brak dokumentów.")}</p>}</div><div className="books-pagination"><Button disabled={!offset} onClick={() => setOffset(Math.max(0, offset - 25))}>{t("Назад", "Wstecz")}</Button><span>{t("Всего", "Łącznie")}: {data.total ?? "—"} · {offset + 1}–{offset + (data.records?.length || 0)}</span><Button disabled={data.total != null ? offset + 25 >= data.total : (data.records?.length || 0) < 25} onClick={() => setOffset(offset + 25)}>{t("Далее", "Dalej")}</Button></div></>}</Load>{newForm && <RecordForm key="new" initial={emptyRecord()} ledger={ledger} base={base} accounts={accounts} sources={sources.data?.documents || []} saved={r => {
      setSelection(r.id);
      setNewForm(false);
      bump();
    }} download={download} refresh={bump} />}{selection && <Load s={detail}>{r => <RecordForm key={`${r.id}-${r.updated_at}`} initial={r} ledger={ledger} base={base} accounts={accounts} sources={sources.data?.documents || []} saved={() => bump()} refresh={bump} download={download} />}</Load>}
<section className="books-detail"><h2>{t("Распределить оплату", "Rozlicz płatność")}</h2><p className="books-notice">{t("Операция банка и её источник должны быть явно проверены. Неоднозначное совпадение не подтверждается автоматически. Без существующей проводки распределите весь перевод одним запросом. Выберите счёт банка из плана счетов компании (не ID банковского реквизита).", "Operacja bankowa i jej źródło muszą być jawnie zweryfikowane. Niejednoznaczne dopasowanie nie jest potwierdzane automatycznie. Bez istniejącego dekretu rozlicz cały przelew w jednym żądaniu. Wybierz konto bankowe z planu kont firmy (nie ID rachunku IBAN).")}</p><form onSubmit={e => {
        e.preventDefault();
        mutation.run("post", `${ledger}/payments`, {
          bank_transaction_id: identifier(payment.bank_transaction_id),
          bank_account_id: identifier(payment.bank_account_id),
          allocations: payment.allocations.map(a => ({
            record_id: identifier(a.record_id),
            amount_pln: decimal(a.amount_pln)
          }))
        }, bump);
      }}><div className="books-toolbar"><Field name="bank_transaction_id" title={t("ID операции банка", "ID operacji bankowej")} value={payment.bank_transaction_id} onChange={v => setPayment({
            ...payment,
            bank_transaction_id: v
          })} /><Account accounts={accounts} title={t("Счёт банка (GL)", "Konto księgowe banku")} value={payment.bank_account_id} onChange={v => setPayment({
            ...payment,
            bank_account_id: v
          })} /></div>{payment.allocations.map((a, i) => <div className="books-toolbar" key={i}><Field name="record_id" value={a.record_id} onChange={v => setPayment({
            ...payment,
            allocations: payment.allocations.map((x, j) => j === i ? {
              ...x,
              record_id: v
            } : x)
          })} /><Field name="amount" decimal value={a.amount_pln} onChange={v => setPayment({
            ...payment,
            allocations: payment.allocations.map((x, j) => j === i ? {
              ...x,
              amount_pln: v
            } : x)
          })} /><Button disabled={payment.allocations.length === 1} onClick={() => setPayment({
            ...payment,
            allocations: payment.allocations.filter((_, j) => i !== j)
          })}>{t("Удалить", "Usuń")}</Button></div>)}<div className="books-actions"><Button onClick={() => setPayment({
            ...payment,
            allocations: [...payment.allocations, {
              record_id: "",
              amount_pln: ""
            }]
          })}>{t("Добавить распределение", "Dodaj rozliczenie")}</Button><button className="books-button" disabled={mutation.state.busy || !payment.bank_account_id} type="submit">{t("Сохранить распределение", "Zapisz rozliczenie")}</button></div></form><Result state={mutation.state} /></section></>;
}
function RecordForm({
  initial,
  ledger,
  base,
  accounts,
  sources,
  saved,
  refresh,
  download
}) {
  const t = useBooksLanguage();
  const [form, setForm] = useState(initial);
  const [note, setNote] = useState("");
  const [kind, setKind] = useState("source");
  const [validation, setValidation] = useState(null);
  const mutation = useMutation();
  const posted = initial.posting_state === "posted";
  const set = (k, v) => {
    setForm(f => ({
      ...f,
      [k]: v
    }));
    setValidation(null);
  };
  const selectedSource = sources.find(d => String(d.id) === String(form.source_document_id));
  return <section className="books-detail"><h2>{initial.id ? `${t("Документ", "Dokument")} #${initial.id}` : t("Новый черновик", "Nowy szkic")}</h2>{initial.id && <SourceData data={Object.fromEntries(["review_state", "posting_state", "settlement_state", "journal_entry_id"].map(k => [k, initial[k]]))} />}<form onSubmit={e => {
      e.preventDefault();
      mutation.run(initial.id ? "patch" : "post", `${ledger}/records${initial.id ? `/${initial.id}` : ""}`, dto(form), r => {
        setForm(r);
        saved(r);
      });
    }}><fieldset disabled={posted || mutation.state.busy} className="books-form-fieldset"><div className="books-form-grid"><label className="books-field">{fieldLabel("dtype", t)}<select className="books-input" value={form.dtype} onChange={e => set("dtype", e.target.value)}>{["purchase", "sale", "loan", "own_transfer"].map(k => <option key={k} value={k}>{t(...states[k])}</option>)}{!states[form.dtype] && <option value={form.dtype}>{form.dtype}</option>}</select></label>{headerFields.map(k => <Field key={k} name={k} value={form[k]} decimal={k.startsWith("declared_")} type={k.endsWith("_date") ? "date" : "text"} onChange={v => set(k, v)} />)}{["name", "nip", "address", "country"].map(k => <Field key={k} name={k} title={`${t("Контрагент", "Kontrahent")} · ${fieldLabel(k, t)}`} value={form.party?.[k]} onChange={v => set("party", {
            ...form.party,
            [k]: v
          })} />)}<Account accounts={accounts} title={fieldLabel("settlement_account_id", t)} value={form.settlement_account_id} onChange={v => set("settlement_account_id", v)} /><label className="books-field">{fieldLabel("source_document_id", t)}<select className="books-input" value={form.source_document_id ?? ""} onChange={e => set("source_document_id", e.target.value)}><option value="">{t("— источник не выбран", "— nie wybrano źródła")}</option>{sources.map(d => <option key={d.id} value={d.id}>#{d.id} · {d.title || d.filename || d.kind}</option>)}</select></label></div><h3>{fieldLabel("lineitems", t)}</h3>{(form.lineitems || []).map((l, i) => <div className="books-line-editor" key={i}><div className="books-form-grid">{["description", "quantity", "unit_price", "net", "vat", "gross", "rate"].map(k => <Field key={k} name={k} value={l[k]} decimal={k !== "description"} onChange={v => set("lineitems", form.lineitems.map((x, j) => j === i ? {
              ...x,
              [k]: v
            } : x))} />)}<label className="books-field">{fieldLabel("vat_regime", t)}<select className="books-input" value={l.vat_regime} onChange={e => set("lineitems", form.lineitems.map((x, j) => j === i ? {
                ...x,
                vat_regime: e.target.value
              } : x))}>{["unknown", "standard", "zero", "exempt", "outside_scope", "reverse_charge"].map(k => <option key={k} value={k}>{t(...states[k])}</option>)}</select></label></div><Button onClick={() => set("lineitems", form.lineitems.filter((_, j) => j !== i))}>{t("Удалить позицию", "Usuń pozycję")}</Button></div>)}<Button onClick={() => set("lineitems", [...form.lineitems, emptyLine()])}>{t("Добавить позицию", "Dodaj pozycję")}</Button><h3>{fieldLabel("posting_lines", t)} · PLN</h3><p>{t("Суммы текстом, запятая допустима. Другая сторона проводки должна явно содержать 0.", "Kwoty wpisuj tekstowo; dozwolony przecinek. Druga strona dekretu wymaga jawnego 0.")}</p>{(form.posting_lines || []).map((l, i) => <div className="books-toolbar" key={i}><Account title={fieldLabel("account_id", t)} accounts={accounts} value={l.account_id} onChange={v => set("posting_lines", form.posting_lines.map((x, j) => j === i ? {
            ...x,
            account_id: v
          } : x))} />{["debit", "credit"].map(k => <Field key={k} name={k} decimal value={l[k]} onChange={v => set("posting_lines", form.posting_lines.map((x, j) => j === i ? {
            ...x,
            [k]: v
          } : x))} />)}<Button onClick={() => set("posting_lines", form.posting_lines.filter((_, j) => j !== i))}>{t("Удалить", "Usuń")}</Button></div>)}<Button onClick={() => set("posting_lines", [...(form.posting_lines || []), {
          account_id: "",
          debit: "",
          credit: "",
          currency: "PLN"
        }])}>{t("Добавить проводку", "Dodaj dekret")}</Button><p><button className="books-button" type="submit">{t("Сохранить черновик", "Zapisz szkic")}</button></p></fieldset></form>
{!posted && <div className="books-toolbar"><Field name="kind" value={kind} onChange={setKind} title={t("Вид вложения", "Rodzaj załącznika")} /><label className="books-field">{t("Загрузить оригинал", "Prześlij oryginał")}<input className="books-input" type="file" disabled={mutation.state.busy} onChange={e => {
          const file = e.target.files?.[0];
          if (!file) return;
          const body = new FormData();
          body.append("file", file);
          body.append("kind", kind);
          mutation.run("post", `${base}/attachments`, body, r => {
            set("source_document_id", r.id ?? r.document?.id ?? r.document_id);
            refresh();
          });
        }} /></label></div>}
{selectedSource && <section className="books-detail"><h3>{t("Полная карточка источника", "Pełna karta źródła")}</h3><SourceData data={selectedSource} /><Button onClick={() => download(`/documents/${selectedSource.id}/download`, selectedSource.filename || `source-${selectedSource.id}.pdf`)}>{t("Скачать источник", "Pobierz źródło")}</Button><Field name="note" value={note} onChange={setNote} /><Button disabled={mutation.state.busy} onClick={() => {
        if (window.confirm(t("Подтвердить проверку этого источника?", "Potwierdzić weryfikację tego źródła?"))) mutation.run("patch", `${base}/documents/${selectedSource.id}`, {
          status: "verified",
          note
        }, refresh);
      }}>{t("Явно подтвердить источник", "Potwierdź weryfikację źródła")}</Button></section>}
{initial.id && <div className="books-actions"><Button disabled={posted || mutation.state.busy} onClick={() => mutation.run("post", `${ledger}/records/${initial.id}/validate`, {}, r => setValidation(r))}>{t("Проверить сохранённый документ", "Sprawdź zapisany dokument")}</Button><Button disabled={posted || mutation.state.busy} onClick={() => {
        if (window.confirm(t("Провести сохранённый документ? Изменение после проводки запрещено.", "Zaksięgować zapisany dokument? Po zaksięgowaniu edycja jest zabroniona."))) mutation.run("post", `${ledger}/records/${initial.id}/post`, {}, refresh);
      }}>{t("Провести", "Zaksięguj")}</Button></div>}{validation && <div className="books-notice"><strong>{validation.valid ?? !validation.blockers?.length ? t("Проверка пройдена", "Walidacja poprawna") : t("Проводка заблокирована", "Księgowanie zablokowane")}</strong><ul>{validation.blockers?.map((k, i) => <li key={i}>{t(`Ошибка проверки: ${k}`, blockers[k] || `Wymagana kontrola księgowa (${k})`)}</li>)}</ul></div>}<Result state={mutation.state} />{initial.id && <details className="books-details"><summary>{t("Все сохранённые поля", "Wszystkie zapisane pola")}</summary><SourceData data={initial} /></details>}</section>;
}
export function Legacy({
  base,
  version
}) {
  const t = useBooksLanguage();
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(0);
  const [id, setId] = useState(null);
  const s = useRead(`${base}/legacy?offset=${offset}&limit=25&search=${encodeURIComponent(search)}`, version);
  const detail = useRead(id ? `${base}/legacy/${id}` : null, version);
  return <><h2>{t("Исторические записи", "Zapisy historyczne")}</h2><form className="books-toolbar" onSubmit={e => {
      e.preventDefault();
      setSearch(query);
      setOffset(0);
      setId(null);
    }}><Field name="search" title={t("Поиск", "Szukaj")} value={query} onChange={setQuery} /><button className="books-button" type="submit">{t("Найти", "Szukaj")}</button></form><Load s={s}>{d => <>{d.notice && <p className="books-notice">{t("Исторические данные источника — не новые оперативные проводки.", "Historyczne dane źródłowe — nie są nowymi dekretami operacyjnymi.")}<br />{d.notice}</p>}{!d.items?.length && <p>{t("Нет записей.", "Brak zapisów.")}</p>}{d.items?.map(r => <div className="books-card" key={r.id}><SourceData data={r} /><Button onClick={() => setId(r.id)}>{t("Все поля и строки источника", "Wszystkie pola i wiersze źródłowe")} #{r.id}</Button></div>)}<div className="books-pagination"><Button disabled={!offset} onClick={() => {
            setOffset(Math.max(0, offset - 25));
            setId(null);
          }}>{t("Назад", "Wstecz")}</Button><span>{t("Всего", "Łącznie")}: {d.total ?? "—"}</span><Button disabled={offset + 25 >= (d.total || 0)} onClick={() => {
            setOffset(offset + 25);
            setId(null);
          }}>{t("Далее", "Dalej")}</Button></div></>}</Load>{id && <section className="books-detail"><h3>{t("Историческая запись", "Zapis historyczny")} #{id}</h3><Button onClick={() => setId(null)}>{t("Закрыть", "Zamknij")}</Button><Load s={detail}>{d => <SourceData data={d} />}</Load></section>}</>;
}
export function Settings({
  base,
  version
}) {
  const t = useBooksLanguage();
  const s = useRead(`${base}/settings`, version);
  return <><h2>{t("Настройки и план счетов", "Ustawienia i plan kont")}</h2><p className="books-notice">{t("Только чтение. Неизвестные страна, система и периоды не заменяются значениями по умолчанию. Используются только счета этой компании.", "Tylko odczyt. Nieznany kraj, system i okresy nie są zastępowane wartościami domyślnymi. Używane są wyłącznie konta tej firmy.")}</p><Load s={s}>{d => <><SourceData data={{
          country: d.company?.country ?? d.company?.country_code,
          accounting_system: d.company?.accounting_system
        }} /><SourceData data={d} /></>}</Load></>;
}
export function TrialBalance({
  base,
  version,
  download,
  JournalDetail
}) {
  const Detail = JournalDetail;
  const t = useBooksLanguage();
  const [buffer, setBuffer] = useState(false);
  const [entry, setEntry] = useState(null);
  const s = useRead(`${base}/trial-balance?include_buffer=${buffer}`, version);
  return <><h2>{t("Рабочая ОСВ", "Robocze zestawienie obrotów i sald")}</h2><label className="books-check"><input type="checkbox" checked={buffer} onChange={e => {
        setBuffer(e.target.checked);
        setEntry(null);
      }} />{t("Включать буфер (по умолчанию нет)", "Uwzględnij bufor (domyślnie wyłączony)")}</label><Load s={s}>{d => <><div className="books-table-wrap"><table className="books-table"><thead><tr>{["account_id", "account_code", "account_name", "debit", "credit", "balance", "entry_ids"].map(k => <th key={k}>{fieldLabel(k, t)}</th>)}</tr></thead><tbody>{(d.items || []).map((r, i) => <tr key={r.account_id ?? i}>{["account_id", "account_code", "account_name", "debit", "credit", "balance"].map(k => <td key={k}><SourceData data={r[k] ?? (k === "account_code" ? r.account : k === "account_name" ? r.name : null)} /></td>)}<td>{(r.entry_ids || []).map(id => <Button key={id} onClick={() => setEntry({
                    id
                  })}>#{id} · {t("Открыть журнал", "Otwórz dziennik")}</Button>)}</td></tr>)}</tbody></table>{!d.items?.length && <p>{t("Нет проводок для выбранного режима.", "Brak zapisów dla wybranego trybu.")}</p>}</div></>}</Load>{entry && <Detail key={entry.id} base={base} entry={entry} download={download} close={() => setEntry(null)} />}</>;
}
